import {BehaviorSubject, ReplaySubject, Subject} from "rxjs";
import {OrderType} from "../order/order";

export class OrderingContextEvents {

    /**
     * Notifies that delivery details have changed.
     */
    public static readonly deliveryDetailsChanged$: Subject<void> = new Subject();

    /**
     * Notifies that selected store details have changed.
     * The value indicates whether the store itself has changed (as opposed to just the table).
     */
    public static readonly storeDetailsChanged$: Subject<boolean> = new Subject();

    /**
     * Notifies the selected order type.
     */
    public static readonly orderType$: Subject<OrderType> = new ReplaySubject(1);

    /**
     * Notifies the marketing opt-in selection
     */
    public static readonly marketingOptIn$: Subject<boolean> = new ReplaySubject(1);

    /**
     * Tracks the fact that we are assessing if there are any impacts to the ordered items after an order time change.
     */
    public static readonly evaluatingExpectedCompletionChange$: BehaviorSubject<boolean> = new BehaviorSubject(false);
}



// WEBPACK FOOTER //
// ./src/app/ordering-context/ordering-context-events.ts